module.exports = __webpack_public_path__ + "img/svg/arrow-down.ed007cb9c005fd1accd49c334d737187.svg";